module.exports = __webpack_public_path__ + "static/logo-dark-eebe80927f92987249438f182a1ee72f.png";